// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2kTvZ","icon":"SortAdornment_icon__1jGla","up":"SortAdornment_up__2pJU2","down":"SortAdornment_down__3fsTg","active":"SortAdornment_active__2hjNk"};